import { createContext, useContext, useState } from 'react'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { Swapagg } from '@fortem-monorepo/web-sdk'

type SwapAggEntry = {
  type: string
  tradeDate: string
  fortemId: string
}

export const useCreateOpsContext = () => {
  type NewMappingContext = Swapagg.AddMappingBody & {
    agentIdDisabled: boolean
  }

  const [newMapping, setNewMapping] = useState<Required<NewMappingContext> | null>(null)
  const [newSwapAggEntry, setNewSwapAggEntry] = useState<SwapAggEntry | null>(null)
  const [isUploadingMappings, setIsUploadingMappings] = useState(false)

  const createNewSwapAggEntry = (fromData?: Partial<SwapAggEntry>) => {
    setNewSwapAggEntry({
      type: '',
      fortemId: '',
      tradeDate: toISO8601(new Date()),
      ...fromData,
    })
  }

  const createNewMapping = (fromData?: Partial<NewMappingContext>) => {
    setNewMapping({
      structurename: '',
      is_agent_id: false,
      external_id: '',
      provider: '',
      from_date: '',
      ...fromData,
      agentIdDisabled: fromData?.agentIdDisabled ?? false,
    })
  }

  const toggleUploadMappingsModal = (show?: boolean) => {
    if (show === undefined) {
      setIsUploadingMappings((prev) => !prev)
      return
    }
    setIsUploadingMappings(show)
  }

  return {
    newMapping,
    setNewMapping,
    createNewMapping,
    newSwapAggEntry,
    setNewSwapAggEntry,
    createNewSwapAggEntry,
    isUploadingMappings,
    toggleUploadMappingsModal,
  }
}

export const opsContext = createContext<ReturnType<typeof useCreateOpsContext> | null>(null)

export const useOpsContext = () => {
  const context = useContext(opsContext)
  if (!context) throw new Error('Ops Context must be used within an Ops Context Provider.')
  return context
}
